import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { ApiEndPoint } from 'src/configurations/constants';

@Injectable({
  providedIn: 'root',
})
export class HomeService {
  httpOptions;
  httpBoday = '';
  tokenData;
  countrieValue;
  buid;
  customFieldId;
  pageIndex = 1;
  pageSize = 10;
  public sendScheduleDataHomeToCalendar: BehaviorSubject<String> = new BehaviorSubject<String>(`ok`);

  constructor(private http: HttpClient) { }

  getActivityChart() {
    this.tokenData = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: this.tokenData,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(ApiEndPoint.Home.activities, this.httpOptions);
  }

  getScheduleData() {
    this.tokenData = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: this.tokenData,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(ApiEndPoint.Home.schedule + `?recordsPerPage=1000&page=1`, this.httpOptions);
  }

  getNotificationData() {
    this.tokenData = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: this.tokenData,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(ApiEndPoint.Home.notifications, this.httpOptions);
  }

  getHomeStatsData() {
    this.tokenData = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: this.tokenData,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(ApiEndPoint.Home.statistics, this.httpOptions);
  }

  getCandidateFlowData() {
    this.tokenData = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: this.tokenData,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(ApiEndPoint.Home.flows, this.httpOptions);
  }

  getCandidateFlowDataByDateFilter(fromDate, toDate) {
    this.tokenData = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: this.tokenData,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(ApiEndPoint.Home.flows + `?from=${fromDate}&to=${toDate}`, this.httpOptions);
  }

  removeJobNotification(body) {
    const tokenData = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: tokenData,
        'language-iso': 'en',
      }),
    };

    return this.http.put<any>(ApiEndPoint.Jobs.notifications, body, this.httpOptions);
  }
}
